import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CalendarHeart } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import { api } from "@/lib/api";

export default function BlogDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`)
      .then((r) => setArticle(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  return (
    <div data-testid="blog-detail-page" className="bg-background min-h-screen">
      <Navbar />
      <main className="pt-32 md:pt-40 pb-10">
        <article className="container-page max-w-3xl">
          <Link to="/articles" data-testid="back-articles" className="inline-flex items-center gap-2 text-forest/70 hover:text-terracotta transition-colors mb-8">
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> All articles
          </Link>

          {notFound && (
            <div className="text-forest/70">
              <h1 className="font-serif text-4xl text-forest">Article not found.</h1>
              <p className="mt-4">It may have been moved or unpublished.</p>
            </div>
          )}

          {article && (
            <>
              <div className="flex items-center gap-3 text-xs tracking-[0.2em] uppercase text-sage">
                <span>{article.category}</span>
                <span className="w-1 h-1 rounded-full bg-sage/50" />
                <span>{article.read_minutes} min read</span>
                <span className="w-1 h-1 rounded-full bg-sage/50" />
                <span>{article.published_at}</span>
              </div>
              <h1 className="font-serif text-5xl md:text-6xl tracking-tight text-forest mt-5 leading-[1.05]">{article.title}</h1>
              <p className="mt-6 text-xl text-forest/75 leading-relaxed">{article.excerpt}</p>

              <div className="mt-10 aspect-[16/9] rounded-3xl overflow-hidden border border-sand">
                <img src={article.cover} alt={article.title} className="w-full h-full object-cover" />
              </div>

              <div className="mt-10 prose-content space-y-6 text-lg leading-relaxed text-forest/85">
                {article.content.map((p, i) => (<p key={i}>{p}</p>))}
              </div>

              <div className="mt-16 rounded-3xl bg-secondary/60 border border-sand p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                <div>
                  <p className="label-eyebrow">Have a personal question?</p>
                  <h3 className="font-serif text-2xl md:text-3xl text-forest mt-2">Book a private consultation</h3>
                </div>
                <Link to="/#book" className="btn-primary"><CalendarHeart className="w-4 h-4" strokeWidth={1.5}/> Book Now</Link>
              </div>
            </>
          )}
        </article>
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
